<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {

      inspectionTitle:'작업발판·비계 및 개구부',
      form: {
        inspectionTitle:'작업발판·비계 및 개구부',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '모든 작업자는 언제나 안전모·안전대 등 보호구를 착용한다.',
          is_checked: '',
          title: '보호구 착용',
        },
        {
          id: 2,
          label: '추락 위험이 있는 모든 장소(개구부, 단부, 작업발판 및 통로의 끝 등)에 안전난간, 울타리, 수직형 추락방망 또는 덮개를 설치하고, 난간 등의 설치가 어려운 경우\n' +
            '      추락방호 망을 설치한다. ',
          is_checked: '',
          title: '추락방지 설비',
        },
        {
          id: 3,
          label: '임시로 난간 등을 해체하거나 추락방호망을 설치하기 어려운 경우, 작업자에게 안전대를 착용하도록 한다. ',
          is_checked: '',
          title: '추락방지 설비',
        },
        {
          id: 4,
          label: '작업자에게 안전대를 착용하게 하는 경우, 안전대 부착설비를 설치하고 작업 시작 전 설비의 이상 유무를 점검한다.',
          is_checked: '',
          title: '추락방지 설비',
        },
        {
          id: 5,
          label: '강관비계보다 시스템비계*를 사용한다.\n' +
            '       *공장에서 각 부재를 표준규격으로 생산하고, 현장에서 조립하여 안전성 확보',
          is_checked: '',
          title: '작업발판 및 비계',
        },
        {
          id: 6,
          label: '시스템비계 설치가 어려워 강관비계를 설치하는 경우 안전난간 및 작업발판의 누락 여부를 철저히 확인한다.',
          is_checked: '',
          title: '작업발판 및 비계',
        },
        {
          id: 7,
          label: '비계에서 작업자가 이동할 때에는 반드시 지정된 통로를 이용하도록 관리한다.',
          is_checked: '',
          title: '작업발판 및 비계',
        },
        {
          id: 8,
          label: '공정 변화에 따른 작업환경 변화 시 사전에 안전한 작업발판 설치방안 등을 검토한다.',
          is_checked: '',
          title: '작업발판 및 비계',
        },
        {
          id: 9,
          label: '이동식비계를 사용할 경우 최상부 안전난간 및 아웃트리거의 설치여부를 철저히 확인한다. ',
          is_checked: '',
          title: '작업발판 및 비계',
        },
        {
          id: 10,
          label: '말비계 등 작업장 내에서 수시로 비계를 설치하여 사용하는 경우 사전에 이상 여부를 확인하고, 기준에 따라 사용하는지 관리한다.',
          is_checked: '',
          title: '작업발판 및 비계',
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
